import { defaultRegistry } from 'react-sweet-state';

import { selectedAgentDraftControllerStore } from './selectedAgentDraftControllerStore';

/**
 * Dismiss every selected agent (`@`-mention override) for a conversation, exactly as
 * if the user had dismissed each agent input hat by hand.
 *
 * Callable from outside React, e.g. from the chat-store action that re-initialises the
 * conversation slot when an agent is picked from the top selector. Callers own the
 * `rovo_chat_mention_agents` gating — this store is ungated by design.
 *
 * Dismissing rather than clearing is what keeps the mention nodes left behind in the
 * prompt document inert: `removeSelectedAgentId` records each id in `deactivatedAgentIds`,
 * so the draft reconciler does not re-activate those chips on the next mount.
 */
export const clearSelectedAgentDraftOverride = (conversationId: string): void => {
	const store = defaultRegistry.getStore(selectedAgentDraftControllerStore);
	const selectedAgentIds = store.storeState.getState().selectedAgentIds[conversationId];

	// Snapshot before dismissing: each dismissal replaces the array held in the store.
	for (const agentId of [...(selectedAgentIds ?? [])]) {
		store.actions.removeSelectedAgentId(conversationId, agentId);
	}
};
